"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
class ApiCredentialsCard extends react_1.default.Component {
    render() {
        const { children } = this.props;
        return (react_1.default.createElement(reactstrap_1.Card, { className: "my-2" },
            react_1.default.createElement(reactstrap_1.CardHeader, null,
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faKey, className: "mr-2" }),
                " API credentials"),
            react_1.default.createElement(reactstrap_1.CardBody, null, children)));
    }
}
exports.ApiCredentialsCard = ApiCredentialsCard;
//# sourceMappingURL=ApiCredentialsCard.js.map